// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3laxg","modalForm":"UpgradeEpcsModal_modalForm__2HhHT","modalFooter":"UpgradeEpcsModal_modalFooter__1k6Ak"};